export const environmentBase = {
  mimeTypes: ['image/jpeg', 'image/png', 'image/gif'],
  maxImgSize: 5 * 1024 * 1024, // 5mb
  appName: 'Portal',
  colors: {},
  chartioUrl: 'https://n8fu0igpz6.execute-api.us-east-1.amazonaws.com/chartio',
  metricsUrl: 'https://dash.brandvno.com/holistics',
  sisenseAppInsightUrl:
    'https://oxio.sisense.com/app/main/dashboards/62f6ae5798f2d4003899cb27',
  sisenseDataCollectionFunnelUrl:
    'https://oxio.sisense.com/app/main/dashboards/6323842f46a6f0003721bdfb',
};
